import React, { useMemo } from "react";
import Arrow from "../../assets/taiga-uikit/icons/arrow-right-1.svg?react";
import { _size, _style } from "../../core/core";
import { Link } from "../link/link";
import "./BreadCrumbs.css";

export interface BreadCrumbLink {
  url: string;
  name: string;
}

interface BreadCrumbsProps {
  links: BreadCrumbLink[];
}

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({
  links = [],
}) => {
  const { breadcrumbLinks, lastLink } = useMemo(() => {
    if (links.length === 0) {
      return { breadcrumbLinks: [], lastLink: null };
    }

    const breadcrumbLinks = links.slice(0, -1);
    const lastLink = links[links.length - 1];

    return { breadcrumbLinks, lastLink };
  }, [links]);

  const jsonLd = useMemo(() => {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        ...breadcrumbLinks.map((l, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: l.name,
          item: l.url,
        })),
        ...(lastLink
          ? [
            {
              "@type": "ListItem",
              position: links.length,
              name: lastLink.name,
              item: lastLink.url,
            },
          ]
          : []),
      ],
    };
  }, [breadcrumbLinks, lastLink, links.length]);

  return (
    <nav aria-label="Breadcrumb" className="bread-crumbs">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <ol itemScope itemType="https://schema.org/BreadcrumbList">
        {breadcrumbLinks.map((link, index) => (
          <li
            key={`${link.url}-${index}`}
            className="breadcrumb-item"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link
              link={link.url}
              size={_size.XS}
              style={_style.link}
              icon_right={<Arrow />}
            >
              <span itemProp="name">{link.name}</span>
            </Link>
            <meta itemProp="position" content={(index + 1).toString()} />
          </li>
        ))}
        {lastLink && (
          <li
            className="breadcrumb-item"
            aria-current="page"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link link={lastLink.url} size={_size.XS} style={_style.link}>
              <span itemProp="name">{lastLink.name}</span>
            </Link>
            <meta
              itemProp="position"
              content={links.length.toString()}
            />
          </li>
        )}
      </ol>
    </nav>
  );
};
